import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "live-caption-content" }
const _hoisted_2 = { class: "speaker-label" }
const _hoisted_3 = { class: "message-text" }

import { ref, watch, nextTick, toRef } from "vue";
import { useLiveCaption } from "@/composables/calls/useLiveCaption";


export default /*@__PURE__*/_defineComponent({
  __name: 'LiveCaption',
  props: {
    isActive: { type: Boolean, default: false },
    enabled: { type: Boolean, default: true },
    callSid: { default: null }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const containerRef = ref<HTMLElement | null>(null);

const { messages } = useLiveCaption({
  callSid: toRef(props, "callSid"),
  isActive: toRef(props, "isActive"),
  enabled: toRef(props, "enabled"),
});

watch(
  () => messages.value.length,
  () => {
    nextTick(() => {
      if (containerRef.value) {
        containerRef.value.scrollTop = containerRef.value.scrollHeight;
      }
    });
  }
);

__expose({ displayedMessages: messages });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "containerRef",
    ref: containerRef,
    class: "live-caption-container"
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "live-caption-header" }, [
      _createElementVNode("span", { class: "live-indicator" }, [
        _createElementVNode("span", { class: "red-dot" }),
        _createTextVNode(" Live Caption ")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_TransitionGroup, {
        name: "caption-fade",
        tag: "div",
        class: "caption-messages"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messages), (message, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `${message.id}-${index}`,
              class: _normalizeClass(["caption-message", message.role.toLowerCase().replace(' ', '-')])
            }, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(message.role) + ":", 1),
              _createElementVNode("span", _hoisted_3, _toDisplayString(message.text), 1)
            ], 2))
          }), 128))
        ]),
        _: 1
      })
    ])
  ], 512))
}
}

})